import { CheckCircle2, XCircle } from "lucide-react";
import { useI18n } from "../../../i18n";
import { JsonBlock } from "./JsonBlock";

export const ResultView = ({ result }) => {
  const { t } = useI18n();
  if (!result) return <p className="rounded-2xl bg-white px-5 py-8 text-center text-sm text-slate-500 shadow-sm">{t("softone.pickMethod")}</p>;
  const Icon = result.success ? CheckCircle2 : XCircle;
  return (
    <div className="space-y-3" data-testid="softone-result">
      <div className="flex flex-wrap items-center gap-3 rounded-2xl bg-white px-5 py-3 text-sm shadow-sm">
        <Icon className={`h-5 w-5 ${result.success ? "text-brand" : "text-rose-600"}`} />
        <span className="font-semibold text-navy" data-testid="softone-result-method">{result.method}</span>
        {result.duration_ms != null && <span className="text-slate-500">{result.duration_ms} ms</span>}
        {result.raw_count != null && <span className="text-slate-500">{t("softone.rawRows")}: {result.raw_count}</span>}
        {result.mapped_count != null && <span className="text-slate-500">{t("softone.mappedCount")}: {result.mapped_count}</span>}
        {result.error && <span className="text-rose-600" data-testid="softone-result-error">{result.error}</span>}
      </div>
      {result.success && (
        <div className="grid gap-3 lg:grid-cols-2">
          <JsonBlock title={t("softone.raw")} data={result.raw} testId="softone-raw-json" />
          <JsonBlock title={t("softone.mapped")} data={result.mapped} testId="softone-mapped-json" />
        </div>
      )}
    </div>
  );
};
